import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BranchSelectionService {
  branchSelected = new EventEmitter<{
    selectedBranch: string;
    branches: any[];
  }>();
  private selectedBranchSubject = new BehaviorSubject<string | null>(null);
  selectedBranch$ = this.selectedBranchSubject.asObservable();
  private companyNameSource = new BehaviorSubject<string | null>(null);
  companyName$ = this.companyNameSource.asObservable();
  branchesLoaded = new EventEmitter<string[]>();

  /* istanbul ignore next */
  setSelectedBranch(branch: string) {
    console.log('set selected branch called', branch);
    this.selectedBranchSubject.next(branch);
  }
  /* istanbul ignore next */
  setCompanyName(name: string): void {
    console.log('Setting company name:', name); // Debug log
    this.companyNameSource.next(name);
  }
  /* istanbul ignore next */
  getSelectedBranch(): string | null {
    return this.selectedBranchSubject.getValue();
  }
  /* istanbul ignore next */
  getCompanyName(): string | null {
    return this.companyNameSource.getValue();
  }
}
